import { render, staticRenderFns } from "./Secure.vue?vue&type=template&id=363ab766&"
import script from "./Secure.vue?vue&type=script&lang=ts&"
export * from "./Secure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports